<template>
    <div :class="className" :style="{height:height,width:width}"/>
</template>

<script>
    import echarts from 'echarts'

    require('echarts/theme/macarons') // echarts theme
    import resize from './mixins/resize'

    export default {
        mixins: [resize],
        props: {
            className: {
                type: String,
                default: 'chart'
            },
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '305px'
            },
            terms: Array
        },
        data() {
            return {
                chart: null,
                termD: [],
                termDD: []

            }
        },
        mounted() {
            this.$nextTick(() => {
                this.initChart()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            this.chart.dispose()
            this.chart = null
        },
        watch() {

        },
        methods: {
            initChart() {
                let termData = this.terms;
                termData.forEach(term => {
                    const r = {
                        value: undefined,
                        name: undefined,
                    }
                    this.termD.push(term.name);
                    let i = 0
                    term.myClasss.forEach(my => {
                        i += my.learn / my.videos == 1 ? 1 : 0;
                    })
                    r.value = i;
                    this.termDD.push(r)
                    r.name = term.name;

                })
                this.chart = echarts.init(this.$el, 'macarons')
                this.chart.setOption({
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        left: 'center',
                        bottom: '10',
                        data: this.termD
                    },
                    series: [
                        {
                            name: '完成课程',
                            type: 'pie',
                            roseType: 'radius',
                            radius: [15, 95],
                            center: ['50%', '38%'],
                            data: this.termDD,
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
                })
            }
        }
    }
</script>
